import { useEffect } from "react";
/* UTILS */
import t from "../../../utils/translate";
import { PHONE_NUMBER } from "../constants";
import useAppContext from "../../AppContext";
/* COMPONENTS */
import Textfield from "../Textfield";
/* STYLES */
import styles from "./styles.module.scss";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber";

const rules = window.ww.validations;

const isValidRegex = (value, regex) => {
  const pattern = new RegExp(regex);

  return pattern.test(value);
};

export const fieldData = {
  [PHONE_NUMBER]: {
    name: PHONE_NUMBER,
    id: PHONE_NUMBER,
    placeholder: t("JS_PHONE_NUMBER_PLACEHOLDER"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("JS_PHONE_NUMBER_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_PHONE_NUMBER_ERROR_INVALID"),
        isNotValid: t("JS_PHONE_NUMBER_ERROR_INVALID")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isMoreThanMax: value => rules.phoneNo.max < String(value).length,
        isInvalidPattern: value => !isValidRegex(value, rules.phoneNo.regex), // update validation regex,
        isNotValid: value => !formatPhoneNumber(value)?.valid
      }
    },
    maxLength: rules.phoneNo.max,
    inputMode: "numeric",
    regexReplace: "^\\d{10}$"
  }
};

const Phone = ({ onChange }) => {
  const { profile, setForceValidation } = useAppContext();
  const { phoneNumber } = profile;

  useEffect(() => {
    if (phoneNumber) {
      setForceValidation(true);
    }
  }, [phoneNumber]);

  return (
    <div className={styles.phone}>
      <Textfield
        {...fieldData[PHONE_NUMBER]}
        value={phoneNumber && formatPhoneNumber(phoneNumber)?.number}
        onChange={onChange}
        styles={styles}
        withAutofocus={false}
        wrapperClassName={styles.inputWrapper}
      />
    </div>
  );
};

export default Phone;
